var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"container margin-top-1 col-7",attrs:{"id":"not-found"}},[_c('div',{staticClass:"no-content-wrapper user-select"},[_c('map-icon',{attrs:{"width":"260","height":"260"}}),_vm._v(" "),_c('p',{domProps:{"textContent":_vm._s(_vm.message)}})],1)])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc15274e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/NotFound.vue
// module id = Gpcb
// module chunks = 0